<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Online Integrations</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header"> UberEats </ng-template>
			<app-integration-ubereats-setup (changesToSaveChange)="changesToSave = $event"></app-integration-ubereats-setup>
		</p-tabPanel>

		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header"> DoorDash </ng-template>
			<app-integration-doordash-setup (changesToSaveChange)="changesToSave = $event"></app-integration-doordash-setup>
		</p-tabPanel>

		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header"> External Integrations </ng-template>
			<app-integration-external-integration-setup (changesToSaveChange)="changesToSave = $event"></app-integration-external-integration-setup>
		</p-tabPanel>

		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header"> Third Party Prices </ng-template>
			<app-integration-third-party-integration-setup (changesToSaveChange)="changesToSave = $event"></app-integration-third-party-integration-setup>
		</p-tabPanel>
	</p-tabView>
</div>
